
import Swal from 'sweetalert2';
import { jwtDecode } from 'jwt-decode';

const DOC_URL = process.env.REACT_APP_DOC_API_URL; 
const API_URL = process.env.REACT_APP_API_URL ;

// const DOC_URL = 'http://localhost:8070/schooldocs';
// const API_URL = 'http://localhost:8070/jmk001/api';

const token = sessionStorage.getItem('token');

const pathUrl = (method, path) => {
    return API_URL + path;
};

const registerLogin = async (url, credentials) => {
    const response = await fetch(`${url}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
    });
    const data = await response.json();
    if (!response.ok) {
        return data;
    }
    sessionStorage.setItem('token', data.accessToken);
    sessionStorage.setItem("hide", true);
    return tokenInfo();
};

const postAuth = async (url, user) => {
    const response = await fetch(`${url}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(user),
    });

    const data = await response.json();
    if (!response.ok) {
        const msg = {
            icon: 'error',
            title: "error",
            text: data.message,
            timer: 15000,
        }
        return showSwal(msg);
    }
    return data;
};

const restPost = async (url, user) => {
    const response = await fetch(`${url}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(user),
    });

    const data = await response.json();
    if (!response.ok) {
        const msg = {
            icon: 'error',
            title: "error",
            text: data.message,
            timer: 10000,
        }
        return showSwal(msg);
    }
    return data;
};

const restPostFormData = async (url, formData) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            // "Content-Type": "multipart/form-data",
        },
        body: formData, // Do NOT use JSON.stringify
    });

    const data = await response.json();
    if (!response.ok) {
        const msg = {
            icon: 'error',
            title: "error",
            text: data.message,
            timer: 15000,
        }
        return showSwal(msg);
    }
    return data;
};

const restPut = async (url, user) => {
    const response = await fetch(`${url}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(user),
    });

    const data = await response.json();
    if (!response.ok) {
        const msg = {
            icon: 'error',
            title: "error",
            text: data.message,
            timer: 10000,
        }
        return showSwal(msg);
    }
    // sessionStorage.setItem('token', data.token);
    return data;
};

const putAuth = async (url, user) => {
    const response = await fetch(`${url}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(user),
    });

    const data = await response.json();
    if (!response.ok) {
        const msg = {
            icon: 'error',
            title: "error",
            text: data.message,
            timer: 15000,
        }
        return showSwal(msg);
    }
    return data;
};

const getAuth = async (url) => {
    const token = sessionStorage.getItem('token');

    const response = await fetch(`${url}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    const data = await response.json();
    if (!response.ok) {
        const msg = {
            icon: 'error',
            title: "error",
            text: data.message,
            timer: 15000,
        }
        return showSwal(msg);
    }
    return data;
};

const restGet = async (url) => {
    const response = await fetch(`${url}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const data = await response.json();
    if (!response.ok) {
        const msg = {
            icon: 'error',
            title: "error",
            text: data.message,
            timer: 10000,
        }
        return showSwal(msg);
    }
    return data;
};

const deleteAuth = async (url, body = null) => {
    try {
        const token = sessionStorage.getItem('token');

        const options = {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        };

        if (body) {
            options.body = JSON.stringify(body);
        }

        const response = await fetch(url, options);

        const contentType = response.headers.get('content-type');

        let data = null;

        if (contentType?.includes('application/json')) {
            data = await response.json();
        } else {
            data = await response.text();
        }

        if (!response.ok) {
            const msg = {
                icon: 'error',
                title: 'Error',
                text: data?.message || data || 'Delete operation failed',
                timer: 15000,
            };

            return showSwal(msg);
        }

        return data;

    } catch (error) {
        console.error('DELETE API Error:', error);

        const msg = {
            icon: 'error',
            title: 'Error',
            text: 'Something went wrong. Please try again.',
            timer: 15000,
        };

        return showSwal(msg);
    }
};

const logout = () => {
    sessionStorage.removeItem('token');
    setTimeout(() => {
        window.location.reload();
    }, 500);
};

const tokenInfo = () => {
    const token = sessionStorage.getItem('token');
    if (token) {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
            // logout();
            return null;
        }
        return decodedToken;
    }
    return null;
};

const tokenInfoNew = () => {
    const token = sessionStorage.getItem('token');
    if (token) {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        const sevenDaysFromNow = currentTime + 7 * 24 * 60 * 60; // 7 days in seconds

        if (decodedToken.exp < currentTime) {
            logout();
            return null;
        }

        if (decodedToken?.is_subscribe < sevenDaysFromNow && !decodedToken.is_subscribe > 0) {
            console.warn("Token is expiring within 7 days");
            Swal.fire({
                icon: 'warning',
                title: "subscription expiring",
                text: 'Subscription is expiring within ' + sevenDaysFromNow + ' days',
                showConfirmButton: true,
            });
        }
        if (7 > decodedToken?.is_subscribe) {
            console.warn("is_subscribe", decodedToken.is_subscribe);
            Swal.fire({
                icon: 'warning',
                title: "Subscription Expired",
                text: 'Your subscription expired ' + String(decodedToken.is_subscribe).replace(/-/g, '') + ' days ago. Kindly renew or subscribe to continue using the service.',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes, Subscribe',
                cancelButtonText: 'No, Later',
                customClass: {
                    confirmButton: 'custom-confirm',
                    cancelButton: 'custom-cancel'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    console.log('User chose to subscribe');
                    window.location.href = '/subscriptionplans';
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    console.log('User declined to subscribe now');
                }
            });

        }

        return decodedToken;
    }
    return null;
};


const showSwal = msg => {
    Swal.fire({
        icon: msg.icon,
        title: msg.title,
        text: msg.text,
        showConfirmButton: false,
        timer: 15000
    })
}

export default {
    restPostFormData,
    registerLogin,
    restPost,
    postAuth,
    restPut,
    putAuth,
    logout,
    restGet,
    getAuth,
    showSwal,
    tokenInfo,
    tokenInfoNew,
    pathUrl,
    deleteAuth,
    DOC_URL
};
